import { createContext } from 'react';

export interface FactsheetOpenStateContextValue {
  code: string | null;
  additionalTabs: string[];
  open: (code: string) => void;
  close: () => void;
  setOpenTabs: (tabs: string[]) => void;
}

export const FactsheetOpenStateContext = createContext<FactsheetOpenStateContextValue>({
  code: null,
  additionalTabs: [],
  open: () => {},
  close: () => {},
  setOpenTabs: () => {}
});
